import request from '../../../../core/wrappers/axios-wrapper';
import { ApiURL } from '../../../../types/constants/apiUrls/api-urls';
import { RequestType } from '../../../../types/enums/request-enums';

const PostPlanning = (data: any): Promise<any> =>
    request({
        url: ApiURL.Command.StudioCommandURLs.PlanningCommandURL.PostPlanning,
        method: RequestType.POST,
        data,
    });

const PostPlanningShot = (data: any): Promise<any> =>
    request({
        url: ApiURL.Command.StudioCommandURLs.PlanningCommandURL.PostPlanningShot,
        method: RequestType.POST,
        data,
    });

const PutPlanning = (data: any): Promise<any> =>
    request({
        url: ApiURL.Command.StudioCommandURLs.PlanningCommandURL.PutPlanning + '/' + data.id,
        method: RequestType.PUT,
        data,
    });

const DeletePlanningShot = (data: any): Promise<any> =>
    request({
        url: ApiURL.Command.StudioCommandURLs.PlanningCommandURL.DeletePlanningShot,
        method: RequestType.POST,
        data,
    });

export const PlanningCommand = {
    PostPlanning,
    PostPlanningShot,
    PutPlanning,
    DeletePlanningShot,
};
